module.exports = __webpack_public_path__ + "static/media/assign sub to teacher.ece4bf66.svg";